import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M19.64 11.124a5.5 5.5 0 0 0-2.195-.457c-2.99 0-5.415 2.388-5.415 5.333s2.424 5.333 5.415 5.333c.782 0 1.525-.163 2.196-.457A6.13 6.13 0 0 1 16.09 22C12.727 22 10 19.314 10 16s2.727-6 6.091-6c1.325 0 2.55.416 3.55 1.124",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "m18.111 17.442-1.586 2.093-.053-2.625-2.48-.863 2.48-.862.053-2.625 1.586 2.093 2.514-.76-1.5 2.154 1.5 2.156z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagTun = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagTun_default = SvgFlagTun;

export { FlagTun_default as default };
